import React, { useState, useEffect } from 'react';
import { Button, Form, Steps, message, notification } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import RegisterPage from './components/RegisterPage';
import FamilyStatus from './components/FamilyStatus';
import SuccessMessage from '@/common/assets/images/successmessage.svg';
// import FamilyDetails from './components/FamilyDetails';
// import PersonalInfo from './components/PersonalInfo';
// import EducationDetails from './components/EducationDetails';
// import ProfilePhoto from './components/ProfilePhotos';
// import Description from './components/Description';
// import PricingPlans from './components/PricingPlans';
// import { pageview, event } from '../../utilities/gtag';
import { useDispatch, useSelector } from 'react-redux';
import {
  countryCodes,
  occupationData,
  maritialStatus,
  familyStatus,
  familyValue,
  familyType,
  siblings_maritial_Status,
  hobbies_list,
  sports_list,
  education_list,
  department_list,
  cities_list,
  signup
} from './redux/slice';
import { Helmet } from 'react-helmet';
import { event, initGA, pageview } from '../../utilities/gtag'; // Adjust path if needed
import Styles from './index.module.less';

const { Step } = Steps;

const RegistrationStepper = () => {
  const location = useLocation();
  // useEffect(() => {
  //   document.title = 'Create your profile on Elite Samskruti Matrimony';
  // }, []);

  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);
  useEffect(() => {
    initGA(); // Initialize GA once on mount
    pageview(window.location.pathname); // Track this pageview
  }, []);

  const [currentStep, setCurrentStep] = useState(0);
  // const [isCheckboxChecked, setIsCheckboxChecked] = useState(false); // ✅ Checkbox State
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  const handleCheckboxChange = (isBothChecked) => {
    setIsButtonEnabled(isBothChecked);
  };

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    country_codes,
    // Occupation_Data,
    maritial_Status,
    family_Status,
    family_Value,
    family_Type
    // siblings_maritialStatus,
    // get_hobbies_list,
    // get_sports_list,
    // education_details,
    // department_details,
    // city_details
  } = useSelector((state) => state.registrations);

  const [formData, setFormData] = useState({
    registerPage: {},
    familyStatus: {},
    familyDetails: {},
    personalInfo: {},
    educationDetails: {},
    profilePhoto: {},
    description: {},
    pricingPlans: {}
  });

  useEffect(() => {
    get_countryCodes();
    get_occupation();
    get_maritialStatus();
    get_familyStatus();
    get_familyValue();
    get_familyType();
    get_siblings_maritialStatus();
    get_hobbies();
    get_sports();
    get_education_details();
    get_department_details();
    get_cities();
  }, []);

  const get_countryCodes = () => {
    dispatch(countryCodes());
  };
  const get_occupation = () => {
    dispatch(occupationData());
  };
  const get_maritialStatus = () => {
    const payload = { type: 'user' };
    dispatch(maritialStatus(payload));
  };
  const get_familyStatus = () => {
    dispatch(familyStatus());
  };
  const get_familyValue = () => {
    dispatch(familyValue());
  };
  const get_familyType = () => {
    dispatch(familyType());
  };
  const get_siblings_maritialStatus = () => {
    dispatch(siblings_maritial_Status());
  };
  const get_hobbies = () => {
    const payload = { type: 'hobby' };
    dispatch(hobbies_list(payload));
  };
  const get_sports = () => {
    const payload = { type: 'sport' };
    dispatch(sports_list(payload));
  };
  const get_education_details = () => {
    dispatch(education_list());
  };
  const get_department_details = () => {
    dispatch(department_list());
  };
  const get_cities = () => {
    dispatch(cities_list());
  };

  const handleback = () => {
    event({
      action: 'click',
      category: 'Navigation',
      label: 'Back Button Clicked',
      value: 1
    });
    navigate('/welcome');
  };

  const steps = [
    {
      title: 'Register',
      key: 'registerPage',
      component: (
        <RegisterPage
          form={form}
          country_codes={country_codes}
          onCheckboxChange={handleCheckboxChange} // ✅ Pass callback
        />
      )
    },
    {
      title: 'Family Status',
      key: 'familyStatus',
      component: (
        <FamilyStatus
          form={form}
          maritial_Status={maritial_Status}
          family_Status={family_Status}
          family_Value={family_Value}
          family_Type={family_Type}
        />
      )
    }
  ];

  useEffect(() => {
    const stepTitle = steps[currentStep]?.title || `Step ${currentStep}`;
    event({
      action: 'step_view',
      category: 'Registration Event',
      label: stepTitle,
      value: currentStep
    });
  }, [currentStep]);

  useEffect(() => {
    if (steps.length > 0 && currentStep >= 0 && currentStep < steps.length) {
      const currentKey = steps[currentStep]?.key;

      if (currentKey) {
        form.setFieldsValue(formData[currentKey] || {});
      } else {
        console.warn(
          'Missing key property in current step:',
          steps[currentStep]
        );
      }
    } else {
      console.warn('Invalid step index or empty steps array:', {
        currentStep,
        steps
      });
    }
  }, [currentStep, form, formData, steps]);

  // console.log('formData', formData);

  const next = async () => {
    event({
      action: 'registration', // event name
      category: 'User Registration',
      label: 'Registration Form Submitted',
      value: 1
    });
    try {
      const values = await form.validateFields();
      const currentKey = steps[currentStep]?.key;

      const updatedData = {
        ...formData,
        [currentKey]: values
      };
      console.log('updatedData', updatedData?.registerPage?.registerPage);
      setFormData(updatedData);
      localStorage.setItem('form_data', JSON.stringify(updatedData));

      // console.log('updatedData', updatedData.registerPage);
      const profile_for_type = localStorage.getItem('profileType');
      const payload = {
        first_name: updatedData?.registerPage?.registerPage.firstName,
        last_name: updatedData?.registerPage?.registerPage.lastName,
        email: updatedData?.registerPage?.registerPage.email,
        mobile_number: updatedData?.registerPage?.registerPage.phoneNumber,
        gender: updatedData?.registerPage?.registerPage.gender,
        profile_for_type_id: profile_for_type,
        agreeTerms: updatedData?.registerPage?.registerPage.agreeTerms,
        receiveEmails: updatedData?.registerPage?.registerPage.receiveEmails,
        country_id: updatedData?.registerPage?.registerPage.countryCode
      };
      // dispatch(signup(payload));
      try {
        // const resultAction = await dispatch(signup(payload));
        const response = await dispatch(signup(payload)).unwrap();
        console.log('API Response:', response);
        if (response?.success) {
          localStorage.setItem('profile_id', response.profile_id);
          // message.success(response.message || 'Form submitted successfully!');
          const duration = 10; // Change duration here

          notification.success({
            key: 'unique_notification',
            message: (
              <span
                style={{
                  color: '#FF6403',
                  fontWeight: 'bold',
                  // fontSize: '16px'
                  marginRight: '10px'
                }}
              >
                Congratulations!
              </span>
            ),
            description: (
              // <div style={{ position: 'relative', whiteSpace: 'nowrap' }}>
              <div>
                <p
                  style={{
                    color: '#FF6403',
                    marginBottom: '8px',
                    // fontSize: '14px',
                    // lineHeight: '1.5',
                    display: 'inline',
                    alignItems: 'center',
                    gap: '10px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    marginRight: '10px'
                  }}
                >
                  Your account has been successfully created. Start your journey
                  to find your perfect match today.
                </p>

                {/* Progress Bar */}
                <div
                  style={{
                    height: '3px',
                    backgroundColor: '#FF6403',
                    position: 'absolute',
                    bottom: '5px',
                    left: 0,
                    width: '100%',
                    animation: `progress-bar ${duration}s linear forwards`
                  }}
                />
                <style>
                  {`
                    @keyframes progress-bar {
                      from { width: 100%; }
                      to { width: 0%; }
                    }
                  `}
                </style>
              </div>
            ),
            duration: duration,
            placement: 'top',
            style: {
              background: 'linear-gradient(to right, #fff3e0, #ffe0b2)',
              borderRadius: '10px',
              width: '100%', // <= let width grow naturally based on content
              // maxWidth: '95%',
              // minWidth: '600px', // optional
              position: 'relative',
              paddingBottom: '20px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
            },
            icon: (
              <img
                src={SuccessMessage}
                alt="success"
                style={{ width: '24px', height: '24px' }}
              />
            ),
            closeIcon: (
              <span
                style={{
                  fontSize: '14px',
                  color: '#FF3D57',
                  cursor: 'pointer'
                }}
                onClick={() => notification.destroy()}
              >
                ❌
              </span>
            )
          });

          navigate('/access');
        } else {
          // message.error(
          //   resultAction.payload?.message || 'Signup failed. Please try again.'
          // );
        }
      } catch (err) {
        message.error('An error occurred. Please try again.');
      }
    } catch (error) {
      console.log('Validation failed:', error);
    }
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  return (
    <>
      <Helmet>
        <title>Create your profile on Elite Samskruti Matrimony</title>
        <meta
          name="description"
          content="Join Elite Samskruti Matrimony by creating your profile today. Our AI-enhanced platform ensures smarter match recommendations based on your preferences and values."
        />
        <meta
          name="keywords"
          content="welcome, elite matrimony, matchmaking, Indian marriage"
        />
        <link rel="canonical" href="https://elite.lexyslabs.com/register" />

        {/* ✅ Add this robots meta tag here */}
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Elite Samskruti Matrimony | Registration Page"
        />
        <meta
          property="og:description"
          content="Find your perfect match through India’s most trusted matchmaking platform."
        />
        <meta
          property="og:image"
          content="https://elite.lexyslabs.com/preview.jpg"
        />
        <meta
          property="og:url"
          content="https://elite.lexyslabs.com/register"
        />
        <meta property="og:type" content="website" />

        {/* Twitter Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Elite Samskruti Matrimony" />
        <meta
          name="twitter:description"
          content="Where elite families find their perfect match."
        />
        <meta
          name="twitter:image"
          content="https://elite.lexyslabs.com/preview.jpg"
        />
      </Helmet>
      <div className={Styles.container}>
        <Steps current={currentStep} style={{ display: 'none' }}>
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>

        <Form form={form} layout="vertical" className={Styles.formContainer}>
          <div>{steps[currentStep].component}</div>

          <div className={Styles.actionbuttons}>
            {currentStep > 0 && (
              <Button
                type="secondary"
                style={{ marginRight: 8 }}
                onClick={prev}
              >
                Back
              </Button>
            )}

            {currentStep === 0 && (
              <>
                <Button
                  type="secondary"
                  onClick={handleback}
                  className={Styles.backbutton}
                  // disabled={!isButtonEnabled} // ✅ Conditionally Enable
                >
                  Back
                </Button>
                <Button
                  type="primary"
                  onClick={next}
                  className={Styles.beginbutton}
                  disabled={!isButtonEnabled}
                  // style={{ color: '#fff', border: '1px solid #D20B0B' }}
                >
                  Let’s Begin
                </Button>
              </>
            )}

            {currentStep > 0 && currentStep < steps.length - 1 && (
              <Button
                type="primary"
                onClick={next}
                className={Styles.nextbutton}
              >
                Next
              </Button>
            )}
          </div>
        </Form>
      </div>
    </>
  );
};

export default RegistrationStepper;
